// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"96":"6a84754f","326":"bd4339ed"}[chunkId] + ".js";
};